module.exports = __webpack_public_path__ + "static/img/account_safe.af9c8ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gaoBaoBan/account_safe.png
// module id = 75se
// module chunks = 39